export const getFormattedPayload = payload =>
  Object.keys(payload).reduce((acc, filterKey) => {
    const selectedValue = payload[filterKey];
    if (selectedValue.length) {
      const transformedValue = selectedValue.map(item => item.value);
      return { ...acc, [filterKey]: transformedValue };
    }
    return { ...acc, [filterKey]: selectedValue };
  }, {});

export const isFilterApplied = filters =>
  Object.keys(filters).some(filter => !!filters[filter].length);

export const initialFiltersValue = {
  salesManager: '',
  channel: '',
  dealership: '',
  outletId: '',
  channelOrgCode: '',
  accountStatus: ''
};
